<template>
  <b-container>
    <b-row>
      <b-col cols="10"> </b-col>
      <b-col cols="2" class="spinner_col" v-if="$store.state.module.live_en_cours && $store.state.fin_selected_course === 'NON'">
        <SpinnerLive></SpinnerLive>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12" class="content_container">
        <transition name="fade">
          <ListParticipants></ListParticipants>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import SpinnerLive from "@/components/Live_tab/SpinnerLive.vue";
import LiveNavigation from "@/components/Live_tab/LiveNavigation.vue";
import ListParticipants from "@/components/Live_tab/ListParticipantsPaginated.vue";
import Podiums from "@/components/Live_tab/Podiums.vue";
import CarteLive from "@/components/Live_tab/CarteLive.vue";
import Passages from "@/components/Live_tab/Passages.vue";
import Webcams from "@/components/Live_tab/Webcams.vue";
import Favoris from "@/components/Live_tab/Favoris.vue";
import Loading from "@/components/Loading.vue";
export default {
  components: {
    LiveNavigation,
    ListParticipants,
    Podiums,
    Passages,
    CarteLive,
    Loading,
    SpinnerLive,
    Webcams,
    Favoris,
  },
  data() {
    return {};
  },
};
</script>

<style lang="sass">
</style>
